import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class ReferenceDataService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}, headers = {}) {
        try {
            const response = await withRetry(
                () => this.api.getAll(params, headers),
                { maxRetries: 2 }
            );
            return {
                success: true,
                data: response.data,
                versions: response.versions,
                _etag: response._etag,
                message: 'Referans verisi getirildi',
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch reference data');
        }
    }

    async seed({ entity, limit } = {}) {
        try {
            return await withRetry(
                () => this.api.seed({ entity, limit }),
                { maxRetries: 2 }
            );
        } catch (error) {
            throw this._handleError(error, 'Seed failed');
        }
    }

    async suggest({ entity, q, limit } = {}) {
        try {
            return await withRetry(
                () => this.api.suggest({ entity, q, limit }),
                { maxRetries: 1 }
            );
        } catch (error) {
            throw this._handleError(error, 'Suggest failed');
        }
    }

    async resolve({ entity, ids } = {}) {
        try {
            return await withRetry(
                () => this.api.resolve({ entity, ids }),
                { maxRetries: 1 }
            );
        } catch (error) {
            throw this._handleError(error, 'Resolve failed');
        }
    }

    async getRegistry() {
        try {
            const response = await withRetry(
                () => this.api.getRegistry(),
                { maxRetries: 2 }
            );
            return {
                success: true,
                data: response.data,
                message: 'Registry getirildi',
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch registry');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
